export type ArtworkSaleStatusValue = 'unavailable' | 'in_auction' | 'sold' | 'unsold'

export interface IArtworkSaleStatusInfo {
  value: ArtworkSaleStatusValue
  label: string
  colorScheme: string
}

interface IArtworkSaleStatusInput {
  available_for_auction?: boolean | number | null
  sale_status?: 'available' | 'sold' | 'unsold' | string | null
}

export function getArtworkSaleStatus(art: IArtworkSaleStatusInput): IArtworkSaleStatusInfo {
  if (art.sale_status === 'sold') {
    return { value: 'sold', label: 'Vendida', colorScheme: 'green' }
  }

  if (art.sale_status === 'unsold') {
    return { value: 'unsold', label: 'Não Vendida', colorScheme: 'red' }
  }

  if (!art.available_for_auction) {
    return { value: 'unavailable', label: 'Não disponível para venda', colorScheme: 'gray' }
  }

  return { value: 'in_auction', label: 'Em leilão', colorScheme: 'orange' }
}
